import { render } from "./index.vue?vue&type=template&id=69a3fa28&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=69a3fa28&lang=less&scoped=true"

import exportComponent from "/Users/gejiayang/Desktop/chunlin-overseas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a3fa28"]])

export default __exports__